import { createAction, handleActions } from 'redux-actions';
import Agent from '../../api/Agent';
import { setAdminRejectReasonStatus } from '../login';
import { handleError } from '../user';

export const setuserinfo = createAction('SET_USERINFO');
export const clearUserInfo = createAction('CLEAR_USERINFO');
export const setShowAdminNotiPref = createAction('SET_ADMIN_SHOW_NOTI_PREF');

const initialState = {
	info: {},
	shift_status: [],
	showAdminNotificationPref: false
};

export default handleActions(
	{
		CLEAR_USERINFO: (state) => ({ ...state, info: initialState.info }),
		SET_ADMIN_SHOW_NOTI_PREF: (state, action) => ({
			...state,
			showAdminNotificationPref: action.payload
		}),
		SET_SHIFT_STATUS_COUNT: (state, action) => ({
			...state,
			shift_status: action.payload
		}),
		SET_USERINFO: (state, action) => ({
			...state,
			info: { ...action.payload, address2: action.payload.additional_address }
		})
	},
	initialState
);

export const userInfo = () =>
	function (dispatch) {
		Agent.userinfo().then((response) => {
			if (response.ok) {
				dispatch(setuserinfo(response.data));
				dispatch(setAdminRejectReasonStatus(response.data.admin_req_reject_reasons));
			} else {
				dispatch(handleError(response));
			}
		});
	};
